import { render, staticRenderFns } from "./BpDefinitionEdgeBuilder.vue?vue&type=template&id=379b0445&"
import script from "./BpDefinitionEdgeBuilder.vue?vue&type=script&lang=js&"
export * from "./BpDefinitionEdgeBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports